import { cn } from '@crm/shared/lib/styles/utils';

export const ErrorTooltip = ({
    id,
    errorMessage,
    side = 'top',
    forceVisible = false,
    className,
}: {
    id?: string;
    errorMessage: string;
    side?: 'top' | 'bottom';
    forceVisible?: boolean;
    className?: string;
}) => (
    <div
        id={id}
        className={cn(
            side === 'top'
                ? 'absolute right-0 bottom-full w-max max-w-44 flex-col items-center justify-start'
                : 'absolute top-full right-0 z-50 mt-1 w-max max-w-44 flex-col items-center justify-start',
            forceVisible ? 'inline-flex' : 'hidden group-focus-within/input-group:inline-flex',
            className
        )}
    >
        {side === 'bottom' && (
            <div
                aria-hidden="true"
                className="absolute right-2.5 bottom-full h-0 w-0 border-x-[5px] border-b-[5px] border-x-transparent border-b-red-500"
            />
        )}
        <div className="flex flex-col items-start justify-start gap-2 self-stretch rounded-lg bg-red-500 px-3 py-2">
            <div className="inline-flex items-center justify-center gap-2.5 self-stretch">
                <div className="flex-1 justify-start text-[10px] leading-3 font-normal text-primary-foreground">
                    {errorMessage}
                </div>
            </div>
        </div>
        {side === 'top' && (
            <div
                aria-hidden="true"
                className="absolute top-full right-2.5 h-0 w-0 border-x-[5px] border-t-[5px] border-x-transparent border-t-red-500"
            />
        )}
    </div>
);
